import { API_BASE_URL_WITHOUT_PATH } from '../../../config/api';

const INGESTION_PATH = '/api/v1/observability/browser-events';
// Precisa bater com MAX_EVENTS_PER_BATCH do receptor.
const MAX_BATCH = 20;

// A SPA de produção é servida pelo Cloudflare Pages, em domínio diferente do da
// API (ver `src/config/api.ts`). Um caminho relativo mandaria o RUM para a
// própria origem da SPA, onde não existe receptor. A origem da API vem da mesma
// configuração central que o httpService usa — sem segunda lógica de URL.
function ingestionUrl(): string {
  try {
    return new URL(INGESTION_PATH, API_BASE_URL_WITHOUT_PATH).href;
  } catch {
    return INGESTION_PATH;
  }
}

function apiOrigin(): string {
  try {
    return new URL(API_BASE_URL_WITHOUT_PATH).origin;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
}

function sampleRate(): number {
  const value = Number(process.env.REACT_APP_BROWSER_OBSERVABILITY_SAMPLE_RATE ?? '0');
  return Number.isFinite(value) && value >= 0 && value <= 1 ? value : 0;
}

export const browserObservabilityConfig = {
  enabled: process.env.REACT_APP_BROWSER_OBSERVABILITY_ENABLED === 'true'
    && process.env.REACT_APP_BROWSER_OBSERVABILITY_PRIVACY_APPROVED === 'true',
  sampleRate: sampleRate(),
  ingestionUrl: ingestionUrl(),
  apiOrigin: apiOrigin(),
  maxBatch: MAX_BATCH,
  frontendVersion: process.env.REACT_APP_VERSION || 'unknown',
};
